import React from 'react'
import { useSessionContext } from 'components/sessions/sessionContext'
import GuestOnboarding from './GuestOnboarding'
import CreateGame from './CreateGame'
import CreateGuestSession from 'components/sessions/CreateGuestSession'

const Onboarding = () => {
  const { session, isGuest } = useSessionContext()

  const username = session?.user?.username
  const isLoggedOut = !username

  if (isLoggedOut) return <CreateGuestSession />
  if (isGuest) return <GuestOnboarding />
  if (!isGuest) return <CreateGame />
  throw new Error(
    'Placeholder: User is logged in, complete journey to create a new game'
  )
}

export default Onboarding
